export const nullSorter = (a, b) => {
  if (a.sortKey === null && b.sortKey === null) {
    return -1;
  } else if (a.sortKey === null) {
    return 1
  } else if (b.sortKey === null) {
    return -1
  } else {
    return a.sortKey - b.sortKey
  }
}